// extracted by mini-css-extract-plugin
export default {"cta":"LG-z","disabled":"MG-z"};